import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

/**
 * PageTransition - Elite Terminal Edition
 * Sayfalar arası geçişi donanım hızlandırmalı ve fizik tabanlı 
 * animasyonlarla lüks bir kullanıcı deneyimine dönüştürür.
 * * + Erişilebilirlik (Reduced Motion) desteği eklendi.
 */
const PageTransition = ({ children }) => {
  // Kullanıcının cihaz ayarlarında "Hareketi Azalt" açık mı?
  const shouldReduceMotion = useReducedMotion();

  const variants = {
    initial: shouldReduceMotion 
      ? { opacity: 0 } 
      : { opacity: 0, y: 15, scale: 0.99 },
    
    animate: { 
      opacity: 1, 
      y: 0, 
      scale: 1 
    },
    
    exit: shouldReduceMotion 
      ? { opacity: 0 } 
      : { opacity: 0, y: -15, scale: 1.01 }
  };

  return (
    <motion.div
      variants={variants}
      initial="initial"
      animate="animate"
      exit="exit"
      // Fizik tabanlı lüks yaylanma efekti
      transition={{
        type: "spring",
        stiffness: 260,
        damping: 25,
        mass: 0.8,
        opacity: { duration: 0.3 }
      }}
      // GPU hızlandırması ve tam genişlik
      className="w-full h-full transform-gpu will-change-transform"
    >
      {children}
    </motion.div>
  );
};

export default PageTransition;